import type { GetInFunction } from './types'

export const getIn: GetInFunction = (cursor = [], obj) => {
  try {
    if (typeof obj === 'undefined' || null === obj) {
      return obj
    }

    if (!cursor.length) {
      return obj
    }

    const [current, ...rest] = cursor
    return getIn(rest, obj[current])
  } catch (_err) {
    return undefined
  }
}
